module.exports = __webpack_public_path__ + "img/nodeType1.f7292e36.svg";